module.exports = __webpack_public_path__ + "img/cross-sq.f490a963.svg";